import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AppConstants } from 'src/app/_helpers/app.constants';
import { CorporateService } from '../../../../_services/corporate/corporate.service';
import * as _ from 'underscore';
import * as moment from 'moment';
import { IDropdownSettings } from 'ng-multiselect-dropdown';


@Component({
  selector: 'app-expense-basic-details',
  templateUrl: './expense-basic-details.component.html',
  styleUrls: ['./expense-basic-details.component.css']
})
export class ExpenseBasicDetailsComponent implements OnInit {

  minDate: any;
  maxDate: any;
  checkIn: any;
  checkOut: any;
  currMinDate: any;
  currMaxDate:  any;
  isTravelUser: any = false;
  isEdit: any = false;

  @Input() expenseFormGroup: FormGroup;
  @Input() tagMembers;
  @Input() tagMembersAct;
  @Input() displayControl;
  @Input() travellersDetails;

  showPurposeOtherElement: boolean = false;
  showApproverSubmittedDate: boolean = false;
  showEmpSubmittedDate: boolean = false;
  selectedTravellesrDetails = [];
  categories = AppConstants.CATEGORIES;
  purposes = AppConstants.PURPOSES;
  finalData: any = {
    basicDetails: {
      category: ''
    }
  };
  isNewBill: any;
  loggedInUser: any;
  startDate: any;
  endDate: any;
  submittedDate: any;
  cat: any;
  defaultPurpose: any;
  tagMembersList: any;

  constructor(
    private controlContainer: ControlContainer,
    private route: ActivatedRoute,
    private corporateService: CorporateService
  ) {
    if (window.localStorage.getItem('currentUser')) {
      this.loggedInUser = JSON.parse(window.localStorage.getItem('currentUser'));
      console.log(this.loggedInUser);
    }

    const current = new Date();
    this.minDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate()
    };
    this.maxDate = {
      year: current.getFullYear(),
      month: current.getMonth(),
      day: current.getDate(),
    };
    this.isNewBill = this.route.snapshot.queryParams['newBill'];
    console.log('isNewBill: ', this.isNewBill, typeof this.isNewBill);
    this.checkViewPermission()
  }

  checkViewPermission() {
    const selBill = JSON.parse(sessionStorage.getItem('selectedBill'));
    console.log('selBill-- ', selBill)
    if (JSON.parse(localStorage.currentUser).roleValue == '5672') {
      this.isTravelUser = false
    }
    if (JSON.parse(localStorage.currentUser).roleValue == '3421') {
      this.isTravelUser = true
    }
    if (JSON.parse(localStorage.currentUser).roleValue == '9918' || '2898' && this.isNewBill != 'true') {
      this.isTravelUser = true
    }
    if (selBill && selBill.key) {
      if (selBill.key == this.loggedInUser.employeeCode) {
        this.isTravelUser = false;
      }
    }


    if (selBill && selBill.reimbursementDetails && selBill.reimbursementDetails.isApplicable == 'Yes') {
      this.isTravelUser = true;
        this.isEdit = true;
    }
    if (JSON.parse(localStorage.currentUser).roleValue == '5672') {
      if (selBill && selBill.approvalDetails) {
         if (selBill.approvalDetails && selBill.approvalDetails.approvalStatus == "draft") {
          this.isTravelUser = false;
         }
      }
    }


    if (JSON.parse(localStorage.currentUser).roleValue == '5672') {
      if (selBill && selBill.approvalDetails) {
         if (selBill.approvalDetails && selBill.approvalDetails.approvalStatus == "pending" ) {
          this.isTravelUser = true;
         }
      }
    }
    if (JSON.parse(localStorage.currentUser).roleValue == '5672') {
      if (selBill && selBill.approvalDetails) {
         if (selBill.approvalDetails && selBill.approvalDetails.approvalStatus == "approved") {
          this.isTravelUser = true;
         }
      }
    }

    if (JSON.parse(localStorage.currentUser).roleValue == '5672') {
      if (selBill && selBill.approvalDetails) {
         if (selBill.approvalDetails && selBill.approvalDetails.approvalStatus == "draft") {
          this.isTravelUser = false;
         }
      }
    }
    if (JSON.parse(localStorage.currentUser).roleValue == '5672') {
      if (selBill && selBill?.approvalDetails == undefined) {
         // if (selBill.approvalDetails && selBill.approvalDetails.approvalStatus === "draft") {
          this.isTravelUser = false;
         // }
      }
    }
    if (JSON.parse(localStorage.currentUser).roleValue == '9918') {
      if (selBill && selBill.approvalDetails) {
         if (selBill.approvalDetails && selBill.approvalDetails.approvalStatus == "pending" ) {
          this.isTravelUser = true;
         }
      }
    }
    if (JSON.parse(localStorage.currentUser).roleValue == '9918') {
      if (selBill && selBill.approvalDetails) {
         if (selBill.approvalDetails && selBill.approvalDetails.approvalStatus == "approved") {
          this.isTravelUser = true;
         }
      }
    }
    if (JSON.parse(localStorage.currentUser).roleValue == '9918') {
      if (selBill && selBill.approvalDetails) {
         if (selBill.approvalDetails && selBill.approvalDetails.approvalStatus == "") {
          this.isTravelUser = false;
          this.isEdit = false;
         }
      }
    }
    if(this.isNewBill){
      this.isTravelUser = false;
    }

    if (JSON.parse(localStorage.currentUser).roleValue == '5672') {
      if (selBill && selBill.approvalDetails) {
         if (selBill.approvalDetails && selBill.approvalDetails.approvalStatus == "") {
          this.isTravelUser = false;
         }
      }
    }
  }

  formatDate(date) {
    return moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD')
  }

  reverseFormatDate(date) {
    return moment(date, 'YYYY-MM-DD').format('DD-MM-YYYY')
  }

  ngOnInit() {
    this.startDate = new Date();
    // this.expenseFormGroup.value.basicDetails.date = new Date();
    //   this.expenseFormGroup.get('basicDetails.date').patchValue(this.formatDate(new Date()));

    // this.expenseFormGroup.controls.basicDetails.controls.date = new Date();
    console.log("k;sk;l",  this.startDate);
    // this.iconTab.get('expenseFormGroup.controls.basicDetails.controls.date').patchValue(this.formatDate(new Date()));

    console.log('id ***', this.route.snapshot.params.id)
    this.expenseFormGroup = <FormGroup>this.controlContainer.control;
    console.log("asdnljslfjdsjflsdj");
    this.getTripSummaryData();
    // this.onSelectAll();
    this.showTravellersDetails();
    this.displayTravellersDetails();
    console.log("asdnljslfjdsjflsdj2222222222");
  //  this.selectedTravellesrDetails = this.travellersDetails;
    console.log("ooooooooo",   this.selectedTravellesrDetails);
    // this.startDate = this.formatDate(this.expenseFormGroup.controls.basicDetails.controls.date)
    // this.expenseFormGroup.controls.basicDetails.patchValue({
    //   date: this.formatDate(this.expenseFormGroup.controls.basicDetails.getRawValue().date)
    // })
    console.log('111 ', this.expenseFormGroup);
    console.log('travellerDetials', );


    // this.getTripSummaryData()
    // let existingBill = JSON.parse(sessionStorage.getItem('selectedBill'));
    // this.expenseFormGroup.value.basicDetails.category = existingBill.category || '';
    // console.log('existing activity--', existingBill, this.expenseFormGroup.value.basicDetails.category)

  }

  getTripSummaryData() {
    this.corporateService.getTripSummaryById(this.route.snapshot.params.id)
      .then((res) => {
        console.log('res ***', res)
        this.defaultPurpose = res['purpose'];
        console.log("  this.defaultPurpose",   this.defaultPurpose);
        this.tagMembersList = (_.pluck(this.travellersDetails, 'travellerName') ) || " ";
        console.log("  this.tagMembersList",   this.tagMembersList);

      })
  }

  dateMatch(input) {
    let reg = /(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d/;
    if (input.match(reg)) {
      return true;
    }
    else {
      return false;
    }
  }

  displayTravellersDetails() {
    const selBill = JSON.parse(sessionStorage.getItem('selectedBill'));
    console.log('displayTravellersDetails ', selBill)
    let that = this;

    if (selBill) {
      this.finalData = selBill || '';
      const tagMembers = selBill.tagMembersFood || selBill.tagMembersTrain || selBill.tagMembersCab || selBill.tagMembersOthers || selBill.tagMembersMeet || selBill.tagMembersMeetMeals || [];
      that.tagMembers = tagMembers;
      console.log("taggerDetalis", tagMembers);
      console.log(that.tagMembers);
      console.log('date--', selBill.basicDetails ?.date);
      this.addTravellerDetails(tagMembers);
    }
    if (selBill && selBill.basicDetails && selBill.basicDetails.date) {
      this.startDate = this.formatDate(selBill.basicDetails ?.date) || ''
      this.endDate = this.formatDate(selBill.basicDetails ?.endDate) || ''
    } else {
      this.startDate = this.formatDate(selBill.meetingStartDate || '') || ''
      this.endDate = this.formatDate(selBill.meetingEndDate || '') || ''
    }
    if(selBill && selBill.basicDetails && selBill.basicDetails.empSubmittedDate &&  selBill.basicDetails.empSubmittedDate.length){
      this.submittedDate = this.reverseFormatDate(selBill.basicDetails.empSubmittedDate)
    }
    let reg = /(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d/;
    this.cat = selBill.basicDetails ?.category || selBill.category || ''
    console.log('********** ', this.startDate, this.cat);
    if (selBill.invoiceDetails && selBill.invoiceDetails ?.state.length || selBill.invoiceDetails ?.city.length || selBill.basicDetails ?.category.length) {
      if (JSON.parse(localStorage.currentUser).roleValue != '5672') {
        this.isEdit = true
      }
    }
    if(selBill.approvalDetails.approvalStatus !== "draft"){
      this.isEdit = true
    }
    if(selBill.approvalDetails.approvalStatus == ""){
      this.isEdit = false;
      // this.isTravelUser = false;
    }

    // if(selBill.approvalDetails.approvalStatus == ""){
    //   this.isEdit = false
    // }
    console.log('finalData ---- ', this.finalData.basicDetails.tagMembers)
    console.log('finalData ---- ', this.finalData)
    // if (this.finalData.key == this.loggedInUser.employeeCode) {
    //   this.isTravelUser = false;
    // }
  }

  onChanged(event?: any) {
    console.log(event)
    console.log(this.finalData);
  }

  showTravellersDetails() {
    this.expenseFormGroup.get('basicDetails').valueChanges.subscribe(selectedVal => {
      const { purposeOther, empSubmittedDate, approverSubmittedDate } = selectedVal;

      this.showPurposeOtherElement = purposeOther ? true : false;
      this.showEmpSubmittedDate = _.isEmpty(empSubmittedDate) ? false : true;
      this.showApproverSubmittedDate = _.isEmpty(approverSubmittedDate) ? false : true;
      this.addTravellerDetails(selectedVal.tagMembers);
    })
  }

  addTravellerDetails(tagMembers) {
    _.map(tagMembers, member => {
      let foundIndex = _.findIndex(this.travellersDetails || [], item => item.travellerName === member)

      if (foundIndex !== -1) {
        this.selectedTravellesrDetails.push(this.travellersDetails[foundIndex])
        this.selectedTravellesrDetails = _.uniq(this.selectedTravellesrDetails, 'employeeCode') || [];
      }
    });
    console.log('travellerdetails----', this.selectedTravellesrDetails);
  }



  onValueSelect($event) {
    console.log('On dropdown select: ', $event.value)
    $event.value === 'Others' ? this.showPurposeOtherElement = true : this.showPurposeOtherElement = false;
  }

  onItemSelect($event) {
    console.log('item select: ', $event)
    this.showTravellersDetails();
  }

  onSelectAll($event) {
    console.log('all select: ', $event)
    this.showTravellersDetails();
  }

  onItemDeSelect($event) {
    let foundIndex = _.findIndex(this.travellersDetails, item => item.travellerName === $event)

    if (foundIndex !== -1) {
      this.selectedTravellesrDetails.splice(foundIndex, 1)
      this.selectedTravellesrDetails = _.uniq(this.selectedTravellesrDetails, 'employeeCode') || [];
    }
  }

  selectCheckIn(event) {
    console.log(event);
    this.currMinDate = event;
    let year = event.year;
    let month = event.month <= 9 ? '0' + event.month : event.month;;
    let day = event.day <= 9 ? '0' + event.day : event.day;;
    let finalDate = day + "-" + month + "-" + year;
    this.expenseFormGroup.value.basicDetails.checkIn = finalDate
    this["checkIn"] = finalDate;
  }

  selectCheckOut(event) {
    console.log(event);
    this.currMaxDate = event;
    let year = event.year;
    let month = event.month <= 9 ? '0' + event.month : event.month;;
    let day = event.day <= 9 ? '0' + event.day : event.day;;
    let finalDate = day + "-" + month + "-" + year;
    this.expenseFormGroup.value.basicDetails.checkOut = finalDate
    this["checkOut"] = finalDate;
  }

}
